<template>
    <svg aria-hidden="true" focusable="false" width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.2553 24.3509H4C3.44772 24.3509 3 23.9031 3 23.3509V7.47586C3 6.92358 3.44772 6.47586 4 6.47586H20.2553C20.8076 6.47586 21.2553 6.92358 21.2553 7.47586V23.3509C21.2553 23.9031 20.8076 24.3509 20.2553 24.3509Z"
            class="stroke"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M7.97872 4.85089V8.10089M16.2766 8.10089V4.85089M3 11.3509H21.2553V7.47589C21.2553 6.92361 20.8076 6.47589 20.2553 6.47589H4C3.44772 6.47589 3 6.92361 3 7.47589V11.3509Z"
            class="stroke"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
